<script>
import axios from 'axios'
import { useIndexStore } from '@src/store'
import { backUrl } from '@src/config.js'
import moment from 'moment-timezone'

export default {
  name: 'ProjectsList',
  emit: [
    'projectSelected',
  ],
  data () {
    return {
      projects: [],
      search: '',
      openedMenu: false,
    }
  },
  computed: {
    store () {
      return useIndexStore()
    },
    filteredProjects() {
      const search = this.search?.trim()
      if (search) {
        return this.projects.filter(item => {
          return (item.name.toLowerCase().includes(search.toLowerCase())
            || this.projectDate(item.date_creation).toLowerCase().includes(search.toLowerCase())
            || item.author.toLowerCase().includes(search.toLowerCase()))
        })
      } else {
        return this.projects
      }
    },
  },
  methods: {
    getAllProjects () {
      axios.get(`${backUrl}projects`).then(response => {
        this.projects = response.data.sort()
      })
    },
    onSelectProject (projectId) {
      this.openedMenu = false
      this.getProjectByID(projectId)
    },
    projectDate (date) {
      return moment(date).format('MMMM Do YYYY')
    },
    getProjectByID (idProject) {
      axios.get(`${backUrl}projects/${idProject}`).then(response => {
        if (response.data.id) {
          this.store.changeProject(response.data)
        }
      })
    },
  },
}
</script>
<template>
  <v-menu
    v-model="openedMenu"
    location="bottom center"
    :close-on-content-click="false"
  >
    <template #activator="{ props }">
      <v-btn
        prepend-icon="fas fa-list"
        variant="elevated"
        color="primary"
        v-bind="props"
        :text="$gettext('Projects list')"
        @click="getAllProjects"
      />
    </template>
    <v-card>
      <template #text>
        <v-text-field
          v-model="search"
          :label="$gettext('Search')"
          prepend-inner-icon="fas fa-search"
          variant="outlined"
          hide-details
          clearable
          single-line
        />
      </template>
      <v-list
        width="25vw"
        max-height="70vh"
      >
        <v-list-item
          v-for="(project, index) in filteredProjects"
          :key="index"
          :value="index"
        >
          <div class="project">
            <div>
              <div class="project-name">
                {{ project.name }}
              </div>
              <div class="project-subtitle">
                {{ $gettext(`Date: ${projectDate(project.date_creation)}`) }}
              </div>
              <div class="project-subtitle">
                {{ $gettext(`Author: ${project.author}`) }}
              </div>
            </div>
            <v-btn
              size="small"
              color="primary"
              :text="$gettext('Open project')"
              @click="onSelectProject(project.id)"
            />
          </div>

          <v-divider
            v-if="index + 1 < projects.length"
            :key="index"
          />
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>
<style lang="scss" scoped>
.project {
  column-gap: 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.project-name {
  max-width: 25ch;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.project-subtitle {
  font-size: 14px;
  color: gray;
}
</style>
